// client/src/pages/Login.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const saved = localStorage.getItem("smsorbit_login_email");
    if (saved) setEmail(saved);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter email and password.");
      return;
    }

    setLoading(true);

    console.log("Login request sent:", { email, password });

    const res = await login(email, password);

    setLoading(false);

    if (!res.ok) {
      setError(res.message || "Login failed");
      return;
    }

    toast.success("Login successful!");

    if (remember) localStorage.setItem("smsorbit_login_email", email);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#05040f] via-[#07071a] to-[#05040f] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md rounded-[30px] bg-white/5 border border-white/10 backdrop-blur-2xl p-8 md:p-10 shadow-[0_40px_120px_rgba(0,0,0,0.7)]"
      >
        <div className="flex flex-col items-center mb-6">
          <Link className="inline-flex items-center justify-center gap-3 mb-3" to="/">
            <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
            <div>
              <div className="font-bold text-lg">SMSOrbit</div>
              <div className="text-xs text-gray-300">Smart SMM Automation Panel</div>
            </div>
          </Link>

          <h1 className="text-2xl md:text-3xl font-bold">Login</h1>
          <p className="text-xs md:text-sm text-gray-300 mt-1">
            Sign in to manage your orders and wallet.
          </p>
        </div>

        {error && (
          <div className="mb-4 rounded-xl bg-red-500/10 border border-red-500/50 px-4 py-2 text-sm text-red-100">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs text-gray-300 mb-1">Email</label>
            <input
              type="email"
              className="w-full px-4 py-2.5 rounded-xl bg-black/40 border border-white/15 text-sm focus:border-purple-400"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-xs text-gray-300 mb-1">Password</label>
            <div className="relative">
              <input
                type={showPass ? "text" : "password"}
                className="w-full px-4 py-2.5 pr-16 rounded-xl bg-black/40 border border-white/15 text-sm focus:border-purple-400"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                className="absolute inset-y-0 right-3 flex items-center text-xs text-gray-300"
              >
                {showPass ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="flex items-center gap-2 text-xs text-gray-300">
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              className="accent-purple-500"
            />
            <span>Remember email</span>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-2 py-3 rounded-xl bg-purple-600 hover:bg-purple-700 shadow-lg font-semibold disabled:opacity-60"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="mt-5 text-xs text-gray-300 text-center">
          New here?{" "}
          <Link to="/register" className="text-purple-300 font-semibold">
            Create Account
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
